import { useNavigation, useRoute } from '@react-navigation/native';
import { useMemo } from 'react';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import useSearch from 'src/hooks/useSearch';
import { DEFAULT_LIST_PAGE_SIZE } from 'src/utils/pagination/listPagination';
import { useEPQuestionSearchQuery, } from '../../graphql/question/questionSearch';
export default function useData() {
    const navigation = useNavigation();
    const route = useRoute();
    const { q: initialQuery = '' } = route.params ?? {};
    const [searchState, searchActions] = useSearch('debounce', 500, initialQuery);
    useEffectWithCtx(ctx => {
        ctx.navigation.setParams({
            q: searchState.deferredVal,
            offset: 0,
            limit: DEFAULT_LIST_PAGE_SIZE,
        });
    }, { navigation }, [searchState.deferredVal]);
    const [listQueryState, listQueryActions] = useEPQuestionSearchQuery();
    const listQueryVars = useMemo(() => {
        const query = searchState.deferredVal.trim();
        return {
            query,
            withAncestorsDetails: true,
        };
    }, [searchState.deferredVal]);
    const state = {
        search: searchState,
        listQuery: listQueryState,
        listQueryVars,
    };
    const actions = {
        search: searchActions,
        listQuery: listQueryActions,
    };
    return [state, actions];
}
